<template>
  <div class="sld_login">
    <div class="sld_login_content" style="height: 960px;">
			<img class="bg" src="../../../assets/user/wx_scan_bg.png"  alt="" />
			<div class="login_wx flex_row_center_center">
				<div class="login_box_wx flex_column_start_center">
          <div class="top_title">{{ L['微信扫码登录'] }}</div>
          <div class="qrMain_code">
            <div class="qrMain_code_bg" :style="`filter:blur(${wxQRout ? '1px' : '0'
                });background-image:url(${wxQRlogShow});background-size:112% 112%;background-position:center;`
                "></div>
            <div v-if="wxQRout" class="qrMain_code_cover">
              <p>{{ L['二维码过期'] }}</p>
              <div @click="wxreCreateQRcode">{{ L['刷新'] }}</div>
            </div>
            <div v-else-if="wxQRsuccess" class="qrMain_code_cover">
              <img class="qrMain_code_success" src="../../../assets/user/reset_password.png" alt="">
              <p class="qrMain_code_cover_p">{{ L['登录成功'] }}</p>
            </div>
            <div v-else-if="wxQRScansuccess" class="qrMain_code_cover">
              <img class="qrMain_code_success" src="../../../assets/user/reset_password.png" alt="">
              <p class="qrMain_code_cover_p">{{ L['扫码成功'] }}</p>
            </div>
          </div>
          <p class="qrMain_title">{{ L['使用微信APP扫码登录'] }}</p>
          <img class="asus_logo" src="../../../assets/user/asus_logo.png" alt="">
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { ref, getCurrentInstance, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

export default {
	name: 'weixin',
	setup() {
		const store = useStore()
		const route = useRoute()

		const router = useRouter()
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage()
    // 微信扫码
		const wxQRlogShow = ref('')
		const wxQRout = ref(false) //二维码是否过期
		const wxQRsuccess = ref(false) //二维码登录成功
    const wxQRScansuccess = ref(false) //二维码扫码成功
		const wxQRissend = ref(null) //二维码登录定时器
		const wxQRcheck = ref(null) //二维码循环定时器

    // 微信--刷新二维码
		const wxreCreateQRcode = () => {
			setTimeout(() => {
				wxQRout.value = false
				wxcreateQRcode()
			}, 200)
		}

		// 生成二维码 (过期定时器、获取扫码状态定时器)
		const wxcreateQRcode = () => {
			proxy.$get('v3/member/front/wx/qr/login/createQrCode').then(res => {
				/* 二维码图片 */
				wxQRlogShow.value = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
				/* 过期定时器 */
				wxQRissend.value = setTimeout(() => {
					console.log('-----二维码过期-----')
					clearTimeout(wxQRissend.value)
					clearInterval(wxQRcheck.value)
					wxQRissend.value = null
					wxQRcheck.value = null
					wxQRout.value = true
				}, 300000)
				/* ------ end ------ */

				let param = {
					ticket: res.data.ticket
				}
				/* 获取扫码状态定时器 */
				wxQRcheck.value = setInterval(() => {
					proxy
						.$post('v3/member/front/wx/qr/login/progress', param)
						.then(result => {
							if(result.data.status == 1){
								console.log('-----扫码成功，请登录-----')
                wxQRScansuccess.value = true
							}
							if (result.data.status == 2) {
                wxQRScansuccess.value = false
								console.log('-----授权登录成功-----')
								wxQRsuccess.value = true
								clearTimeout(wxQRissend.value)
								clearInterval(wxQRcheck.value)
								wxQRissend.value = null
								wxQRcheck.value = true

								localStorage.setItem('refresh_token', result.data.refreshToken)
								/* 更新 access_token */
								let params = new FormData()
								params.append('grant_type', 'refresh_token')
								params.append('refresh_token', result.data.refreshToken)
								params.append('source', 1)

								proxy.$post('v3/frontLogin/oauth/token', params, {
									headers: {
										'Content-Type': 'multipart/form-data',
										Authorization: 'Basic ZnJvbnQ6ZnJvbnQ='
									}
								}).then(
									response => {
										if (response.state == 200) {
											localStorage.setItem('access_token', response.data.access_token)
											localStorage.setItem('time', new Date().getTime().toString()) //存储refresh_token更新时间

											/* 获取用户信息，并同步信息到vuex */
											proxy.$get('v3/member/front/member/getInfo').then(res_info => {
												if (res_info.state == 200) {
													store.commit('updateMemberInfo', res_info.data)
													proxy.$getLoginCartListData() //更新购物车数据
                          router.replace({ path: '/' })
													// if (window.history.state.back) {
													// 	router.back()
													// } else {
													// 	router.replace({ path: '/home/index' })
													// }
												}
											})
											/* ------ end ------ */
										}
                    let eventParams = {
                      login_type: 2,
                      is_success: response.state == 200 ? true : false,
                      fail_errorcode:response.state,
                      fail_reason: response.msg
                    }
				            proxy.$drgStatEvent('amall_login_fe', eventParams)
									},
									err => {
										console.log('更新access_token出错：', err)
									}
								)
								/* ------ end ------ */
							}
						})
				}, 3000)
				/* ------ end ------ */
			})
		}
		//通过replace方式跳转页面
		const goToPage = type => {
			router.push({
				path: type
			})
		}
		onMounted(() => {
      if (route.query.action === 'createWxQRCode') {
        wxcreateQRcode();
      }
		})
		return {
			L,
      goToPage,
      wxQRout,
			wxQRsuccess,
      wxQRScansuccess,
			wxQRlogShow,
			wxQRissend,
			wxQRcheck,
			wxcreateQRcode,
			wxreCreateQRcode,

		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../../style/login.scss';
@import '../../../style/base.scss';

.login_wx{
  width: 1320px;
  height: 100%;
  margin: auto;
  z-index: 99;
  position: relative;
  .login_box_wx{
    position: relative;
    z-index: 10000;
    padding: 30px auto;
    width: 538px;
    height: 602px;
    background: #FFFFFF;
    box-shadow: 0px 8px 20px 0px rgba(84,86,96,0.15);
    border-radius: 4px 4px 4px 4px;
    .top_title{
      font-family: Microsoft YaHei,Microsoft YaHei;
      font-weight: bold;
      font-size: 30px;
      color: #000000;
      line-height: 35px;
      margin-top: 75px;
      margin-bottom: 55px;
    }
    .qrMain_code{
      position: relative;
      width: 240px;
      height: 240px;
      // background-color: #1E7CFF;
      .qrMain_code_bg {
          width: 100%;
          height: 100%;
      }
      .qrMain_code_cover {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
          color: #ffffff;
          text-align: center;
          p {
              // font-size: 19px;
              // font-weight: 700;
              margin-top: 84px;
              margin-bottom: 20px;
              font-family: Microsoft YaHei,Microsoft YaHei;
              font-weight: 500;
              font-size: 20px;
              color: #FFFFFF;
              line-height: 20px;
          }
          .qrMain_code_success{
              margin-top: 65px;
              width: 70px;
              height: 70px;
          }
          .qrMain_code_cover_p {
              margin-top: 20px;
          }
          div {
              // width: 100px;
              // line-height: 34px;
              // font-size: 13px;
              // font-weight: 700;
              letter-spacing: 1px;
              // background: #e2231b;
              // border-radius: 3px;
              margin: 0 auto;
              cursor: pointer;
              font-family: Microsoft YaHei,Microsoft YaHei;
              font-weight: 400;
              font-size: 16px;
              color: #FFFFFF;
              line-height: 36px;
              width: 102px;
              height: 36px;
              background: #1E7CFF;
              border-radius: 4px 4px 4px 4px;
          }
      }
    }
    .qrMain_title{
      font-family: Microsoft YaHei,Microsoft YaHei;
      font-weight: 400;
      font-size: 18px;
      color: #888E98;
      line-height: 20px;
      margin-top: 15px;
      margin-bottom: 96px;
    }
    .asus_logo{
      width: 123px;
      height: 36px;
    }

  }
}
</style>
